import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { usePartner } from 'components/app/routes/usePartner';
import { addQueryString, addHash } from 'machines/utils/misc';

export const useOnExit = () => {
  const history = useHistory();
  const { partnerName } = usePartner();

  useEffect(() => {
    const onExit = () => {
      const state = {
        partnerName
      };
      const currentFullPath = addHash(
        addQueryString(history.location.pathname, history.location.search),
        history.location.hash
      );

      //save state (partnerName) to history for current path before exiting the app
      history.replace(currentFullPath, state);
    };
    window.addEventListener('pagehide', onExit);

    return () => {
      window.removeEventListener('pagehide', onExit);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
